import { StrictMode } from 'react'

import ReactDOM from 'react-dom/client'

import { AuthProvider } from '@enechain/auth-js'

import '~/i18n'
import { AppChakraProvider } from '~/provider/AppChakraProvider'
import { AppProvider } from '~/provider/AppProvider'
import { AppRouteProvider } from '~/provider/AppRouteProvider'
import { HeadProvider } from '~/provider/HeadProvider'
import { initializeDatadogRUM } from '~/utils/datadog'

// Initialize Datadog RUM before rendering the app
if (import.meta.env.VITE_DD_ENABLED === 'true') {
  initializeDatadogRUM()
}

const rootElement = document.getElementById('root')
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)

  root.render(
    <StrictMode>
      <HeadProvider>
        <AuthProvider
          loginUrl={import.meta.env.VITE_ELOGIN_URL}
          apiUrl={import.meta.env.VITE_ELOGIN_API_URL}
          redirectUri={window.location.origin}
        >
          <AppChakraProvider>
            <AppProvider>
              <AppRouteProvider />
            </AppProvider>
          </AppChakraProvider>
        </AuthProvider>
      </HeadProvider>
    </StrictMode>,
  )
}
